var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":5000,"indicator-color":"#1baeae"}},_vm._l((_vm.list),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item.carouselUrl,"alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }